/**
 * Storage Module
 * 
 * Handles storage panel with disk usage and database info.
 */

import { api, StorageInfo } from './api';

/**
 * Initialize storage panel.
 */
export function initStorage(): void {
    refreshStorage();
}

/**
 * Refresh storage info from API.
 */
export async function refreshStorage(): Promise<void> {
    try {
        const storage = await api.getStorage();
        renderStorage(storage);
    } catch (err) {
        console.error('Failed to fetch storage:', err);
    }
}

// ============================================================================
// Rendering
// ============================================================================

function renderStorage(storage: StorageInfo): void {
    // Disk usage bar
    const usedBar = document.getElementById('disk-used-bar');
    if (usedBar) {
        usedBar.style.width = `${storage.disk.used_percent}%`;
    }

    // Disk labels
    const diskUsed = document.getElementById('disk-used');
    const diskTotal = document.getElementById('disk-total');
    if (diskUsed) {
        diskUsed.textContent = `${formatSize(storage.disk.total_gb - storage.disk.free_gb, 'GB')} used`;
    }
    if (diskTotal) {
        diskTotal.textContent = `${formatSize(storage.disk.total_gb, 'GB')} total`;
    }

    // Databases
    const dbList = document.getElementById('databases-list');
    if (dbList) {
        dbList.innerHTML = storage.databases.map(db => `
      <div class="db-row">
        <span class="db-name">${escapeHtml(db.name)}</span>
        <span class="db-size">${formatSize(db.size_mb, 'MB')}</span>
      </div>
    `).join('');
    }

    // Counts
    const mediaCount = document.getElementById('media-count');
    const docsCount = document.getElementById('documents-count');
    if (mediaCount) {
        mediaCount.textContent = storage.media_count.toLocaleString();
    }
    if (docsCount) {
        docsCount.textContent = storage.documents_count.toLocaleString();
    }
}

// ============================================================================
// Helpers
// ============================================================================

function formatSize(value: number, unit: string): string {
    return `${value.toFixed(1)} ${unit}`;
}

function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
